export default __webpack_public_path__ + "static/media/PPI-steps-002.09714fd1.jpg";